module.exports = __webpack_public_path__ + "static/media/list-view.321a25b7.svg";